import appSettings from '../appsettings.json'

export const useAppSettings = () => appSettings;
